import { createProfessionalExporter } from '../../../utils/professionalExport';
import { formatPrice } from './subscriptionData';

const headers = ['Gym', 'Email', 'Plan', 'Billing Cycle', 'Price', 'Expiry Date', 'Source', 'Status'];

function formatStatus(status) {
  return status.charAt(0).toUpperCase() + status.slice(1);
}

const exporter = createProfessionalExporter({
  title: 'Subscription List',
  headers,
  slug: 'subscriptions',
  brand: 'owner',
  getRows: (list) =>
    list.map((sub) => [
      sub.gym,
      sub.contactEmail || '—',
      sub.planName,
      sub.billingCycle,
      formatPrice(sub.price),
      sub.expiryDate,
      sub.source === 'signup' ? 'Signup' : 'Manual',
      formatStatus(sub.status),
    ]),
  getSummary: (list) => [
    `Total subscriptions: ${list.length}`,
    `Active: ${list.filter((s) => s.status === 'active').length}`,
    `Manual: ${list.filter((s) => s.source === 'manual').length}`,
    `Signup: ${list.filter((s) => s.source === 'signup').length}`,
  ],
});

export const printSubscriptionList = (data) => exporter.print(data);
export const exportSubscriptionCsv = (data) => exporter.csv(data);
export const exportSubscriptionExcel = (data) => exporter.excel(data);
export const exportSubscriptionPdf = (data) => exporter.pdf(data);
export const exportSubscriptions = (data) => exporter.export(data);
